export enum BookingKitStatusType {
  Created = "Created",

  SentToHBA = "SentToHBA", // Skickad till HBA
  ApprovedByHBA = "ApprovedByHBA", // Godkänd av HBA
  RejectedByHBA = "RejectedByHBA", // Nekad av HBA

  SentToOC = "SentToOC", // Skickad till OC
  ApprovedByOC = "ApprovedByOC", // Godkänd av OC
  RejectedByOC = "RejectedByOC", // Nekad av OC

  /**
   * @deprecated
   */
  SentToFinance = "SentToFinance", // Skickad till Ekonomi
  /**
   * @deprecated
   */
  ApprovedByFinance = "ApprovedByFinance", // Godkänd av Ekonomi
  /**
   * @deprecated
   */
  RejectedByFinance = "RejectedByFinance", // Nekad av Ekonomi

  SentToFinancePayment = "SentToFinancePayment", // Skickad till Ekonomi - Betalning
  ApprovedByFinancePayment = "ApprovedByFinancePayment", // Godkänd av Ekonomi - Betalning
  RejectedByFinancePayment = "RejectedByFinancePayment", // Nekad av Ekonomi - Betalning

  SentToFinanceInvoicing = "SentToFinanceInvoicing", // Skickad till Ekonomi - Kundfakturering
  ApprovedByFinanceInvoicing = "ApprovedByFinanceInvoicing", // Godkänd av Ekonomi - Kundfakturering
  RejectedByFinanceInvoicing = "RejectedByFinanceInvoicing", // Nekad av Ekonomi - Kundfakturering

  Done = "Done", // Hanterad ("Done")
  Deleted = "Deleted" // Raderad ("Deleted")
}
